import { createFileRoute } from "@tanstack/react-router";
import FaqArticlePage from "@/site/pages/faq-article";

export const Route = createFileRoute("/faq/$category/$article")({
  component: FaqArticlePage,
});
